/** A markdown description flattened to one line of plain text, for rows that show only a clamped preview. */
export function markdownLine(markdown: string | undefined): string {
  if (!markdown) return "";
  return markdown
    .replace(/!?\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/^\s{0,3}(#{1,6}\s+|>\s?|[-*+]\s+|\d+\.\s+)/gm, "")
    .replace(/(\*\*|__|\*|_|~~|`)(.+?)\1/g, "$2")
    .replace(/\s+/g, " ")
    .trim();
}
